export default __webpack_public_path__ + "static/media/Toji Fushiguro.f01a1aba.mp3";